/**
 *
 * native 'closest' method for Element with polyfill if 'closest' is not available (IE and Edge)
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
 *
 * @memberOf Common.Utils.Element
 *
 * @param {node} el : descendant element
 * @param {string} targetSelector : selector of ancestor to find
 * @returns {node} : closest ancestor to el that matches targetSelector
 */
const findClosestAncestor = (el, targetSelector) => {
  if (Element.prototype.closest) {
    return el.closest(targetSelector);
  } else {
    if (!Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }
    if (!document.documentElement.contains(el)) return null;
    let element = el;
    do {
      if (element.matches(targetSelector)) return element;
      element = element.parentElement || element.parentNode;
    } while (element !== null && element.nodeType === 1);
    return null;
  }
};

export { findClosestAncestor };
